import { render } from "./DetalleCompra.vue?vue&type=template&id=c0d0e6ae&scoped=true"
import script from "./DetalleCompra.vue?vue&type=script&lang=js"
export * from "./DetalleCompra.vue?vue&type=script&lang=js"

import "./DetalleCompra.vue?vue&type=style&index=0&id=c0d0e6ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d0e6ae"]])

export default __exports__